<script setup>
import { ref, onMounted } from "vue";
import Toast from "primevue/toast";
import { setToastInstance } from "@/utils/notification";
import { useAuthStore } from "./stores/authStore";

const toast = ref(null);
const authStore = useAuthStore();

if (authStore.token && authStore.user) {
  authStore.connectToChat();
  authStore.loadProfileImage();
}
onMounted(() => {
  setToastInstance(toast.value);
});
const appVersion = "v1.3.0";
</script>

<template>
  <Toast ref="toast" />
  <router-view />
  <footer class="app-version-footer">
    <p>Version: {{ appVersion }}</p>
  </footer>
</template>

<style scoped>
.app-version-footer {
  position: fixed;
  /* Keep it at the same spot even when scrolling */
  bottom: 0;
  right: 0;
  padding: 5px 10px;
  background-color: #f0f0f0;
  /* Light background for visibility */
  border-top: 1px solid #ccc;
  font-size: 0.75rem;
  color: #666;
  z-index: 1000;
  /* Ensure it's above other elements */
}

.app-version-footer p {
  margin: 0;
}
</style>